
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.502 17.01l5.074 5.075a.758.758 0 01-1.072 1.072l-6.431-6.431a.758.758 0 010-1.072l6.431-6.432a.758.758 0 011.072 1.072l-5.2 5.2h12.866a.758.758 0 010 1.517h-12.74z","fill":"#6349E9"}}),_c('path',{attrs:{"d":"M16 32a16 16 0 1116-16 16.018 16.018 0 01-16 16zm0-30.316A14.316 14.316 0 1030.316 16 14.332 14.332 0 0016 1.684z","fill":"#6349E9"}})])
          )
        }
      }
    